module.exports = __webpack_public_path__ + "img/404.b62ee6e4.svg";